"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Transition = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
const Transition = exports.Transition = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const theme = (0, _material.useTheme)();
  const [screenWidth, setScreenWidth] = (0, _react.useState)(400);
  (0, _react.useEffect)(() => {
    setScreenWidth(window.innerWidth);
    function handleResize() {
      setScreenWidth(window.innerWidth);
    }
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  if (screenWidth >= theme.breakpoints.values.sm) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Fade, {
      ref: ref,
      ...props
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Slide, {
    ref: ref,
    direction: "up",
    ...props
  });
});
